import React from 'react'
import PropTypes from 'prop-types'

import { Field } from 'react-final-form'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import TextField from '../../ui/Fields/TextField'
import Select from '../../ui/Fields/Select'
import styles from '@styles/forms'

const Form = props => {
  const {
    action,
    classes,
    handleSubmit,
    selectValues: { ownershipTypes },
    o
  } = props

  const currentYear = new Date().getFullYear()

  return (
    <form className={classes.form} onSubmit={handleSubmit} data-testid="tractor-equipment-form">
      <main className={classes.form__fields}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                label={I18n.t('v4/equipment.attributes.name')}
                margin="normal"
                name="equipment[name]"
                InputLabelProps={{ shrink: true }}
                required
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.power_output')}
                margin="normal"
                name="equipment[power_output]"
                required
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.fuel_capacity')}
                margin="normal"
                name="equipment[fuel_capacity]"
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={Select}
                data={ownershipTypes}
                fields={{ id: 'id', name: 'name' }}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.ownership')}
                name="equipment[ownership]"
                margin="normal"
                required
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.manufacturer')}
                margin="normal"
                name="equipment[manufacturer]"
                required
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.equipment_model')}
                margin="normal"
                name="equipment[equipment_model]"
                required
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.year')}
                margin="normal"
                name="equipment[year]"
                inputProps={{ min: '1900', max: currentYear }}
                variant="outlined"
                type="number"
              />
            </div>
          </Grid>

          <Grid item xs={12}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.detail')}
                margin="normal"
                name="equipment[detail]"
                multiline
                variant="outlined"
              />
            </div>
          </Grid>
        </Grid>
      </main>

      <footer className={classes.form__actions}>
        <Button
          className={classes.form__action}
          color='primary'
          type='submit'
          variant='contained'
        >
          {`${action} ${I18n.t('v4/equipment.kinds.tractor')}`}
        </Button>

        <Button
          className={classes.form__action}
          color='secondary'
          href={`/v4/o/${o}/equipments/tractor`}
        >
          {I18n.t('actions.back')}
        </Button>
      </footer>
    </form>
  )
}

Form.propTypes = {
  action: PropTypes.string,
  selectValues: PropTypes.objectOf(PropTypes.array)
}

export default withStyles(styles)(Form)
